var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPharmacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 17,
    viewBox: "0 0 29 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.843 3.3125L20.0305 6.12501",
    stroke: "white",
    strokeWidth: 0.843753
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30908 6.15172C4.57144 4.58271 6.05181 3.52398 7.61618 3.78689C9.18028 4.05007 10.2357 5.53508 9.97335 7.10436",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8006 8.4893V13.1363C16.8006 14.4419 15.7457 15.5001 14.4442 15.5001C13.143 15.5001 12.0881 14.4419 12.0881 13.1363V7.58521",
    stroke: "white",
    strokeWidth: 1.68751
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.03178C4.74808 3.41595 19.4147 12.4659 27.8888 7.03178",
    stroke: "white",
    strokeWidth: 0.843753
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0881 7.61917V2.85741C12.0881 1.55536 13.1402 0.5 14.4382 0.5C15.7359 0.5 16.788 1.55536 16.788 2.85741V8.52737",
    stroke: "white",
    strokeWidth: 0.843753
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99334 7.10425C9.73125 8.67326 8.25061 9.73199 6.68651 9.46908C5.12214 9.2059 4.06671 7.72089 4.32907 6.15161",
    stroke: "white",
    strokeWidth: 0.843753
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.463 12.3247C19.463 11.2161 20.3591 10.3171 21.4643 10.3171C22.5697 10.3171 23.4658 11.2161 23.4658 12.3247C23.4658 13.4333 22.5697 14.3322 21.4643 14.3322C20.3591 14.3322 19.463 13.4333 19.463 12.3247Z",
    stroke: "white",
    strokeWidth: 0.843753
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.463 4.65306C19.463 3.54442 20.3591 2.64551 21.4643 2.64551C22.5697 2.64551 23.4658 3.54442 23.4658 4.65306C23.4658 5.7617 22.5697 6.66061 21.4643 6.66061C20.3591 6.66061 19.463 5.7617 19.463 4.65306Z",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyIcon);
export default __webpack_public_path__ + "static/media/pharmacy-icon.8a1f894d2ef2b7f69a0f88bfc838cc65.svg";
export { ForwardRef as ReactComponent };